import React from "react"

export const ArrowCurved = ({
  direction = "up",
  size = 1,
  color = "#F0C202",
  strokeWidth = "3",
}) => {
  const rotiations = {
    down: 180,
    up: 0,
    left: -90,
    right: 90,
  }

  return (
    <svg
      width={62 * size}
      height={50 * size}
      viewBox="0 0 62 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        // marginBottom: (7 * size) / 2,
        transform: `rotate(${rotiations[direction]}deg)`,
        transition: "all 0.2s ease",
        overflow: "visible",
      }}
    >
      <g>
        <g>
          <path
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            d="M0.5,47.5c41.6,0,57-12.2,58-43.7"
          />
          <g>
            <polygon
              fill={color}
              points="70,14.4 67.7,16.3 58.2,4.9 47.5,15.1 45.5,12.9 58.5,0.5 			"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
